<template>
    <div class="inspect widget">
        <slot></slot>
        <div class="content none" v-if="!hasContent">
            <div class="icon">
                <awesome-icon icon="search"></awesome-icon>
            </div>
            <div class="descr">
                Click an item to view the details
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "sc-table-inspect",

    props: {
      hasContent: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
    .inspect {
        flex: 1;
    }

    .none .icon {
        color: #333;
    }

    .none {
        padding: 48px 0;
        color: #ccc;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .none .descr {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 0.8em;
    }

    .none .icon {
        color: #eee;
        font-size: 5em;
        padding-bottom: 8px;
    }
</style>